<template>
  <div>
    <label class="d-inline-block mb-2 subtitle-2">{{ label }}</label>
    <v-text-field
      v-model="password"
      :type="isPassowrdVisible ? 'text' : 'password'"
      :append-icon="isPassowrdVisible ? 'mdi-eye' : 'mdi-eye-off'"
      outlined
      dense
      background-color="white"
      :rules="[validationRules]"
      @click:append="isPassowrdVisible = !isPassowrdVisible"
    />
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    validationRules: {
      type: [String, Boolean],
      required: false,
      default: () => true
    }
  },
  computed: {
    password: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  data () {
    return {
      isPassowrdVisible: false
    }
  }
}
</script>
